import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_RESTAURANT,
  REQUEST_CREATE_MASTER_RESTAURANT,
  SET_MASTER_RESTAURANT,
  SUCCESS_CREATE_MASTER_RESTAURANT,
  ERROR_GET_MASTER_RESTAURANT,
  ERROR_CREATE_MASTER_RESTAURANT,
  SUCCESS_DELETE_MASTER_RESTAURANT,
  SUCCESS_UPDATE_MASTER_RESTAURANT,
  REQUEST_DELETE_MASTER_RESTAURANT,
  REQUEST_UPDATE_MASTER_RESTAURANT,
  ERROR_DELETE_MASTER_RESTAURANT,
  ERROR_UPDATE_MASTER_RESTAURANT,
} from "./restaurantActionTypes";

function* requestMasterRestaurant(action: Record<string, any>): any {
  try {
    const result: any = yield call(getRestaurantMaster);
    yield put({ type: SET_MASTER_RESTAURANT, payload: result.data.data });
    // console.warn(result.data.data, "jhuihihi");
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_RESTAURANT, payload: message });
  }
}

function* requestUpdateMasterTagRestaurant(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterRestaurant,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_RESTAURANT,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_RESTAURANT, payload: message });
  }
}

function* requestDeleteMasterTagRestaurant(action: Record<string, any>): any {
  try {
    yield call(deleteMasterRestaurant, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_RESTAURANT,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_RESTAURANT, payload: message });
  }
}

function* requestCreateMasterRestaurant(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterRestaurant, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_RESTAURANT,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_RESTAURANT, payload: message });
  }
}

export function getRestaurantMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/restaurant`,
    withCredentials: true,
  });
}

export function createMasterRestaurant(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/restaurant`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterRestaurant(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/restaurant/${_id}`,
    withCredentials: true,
  });
}
export function updateMasterRestaurant(
  payload: Record<string, any>,
  _id: string
) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/restaurant/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

const restaurantMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_RESTAURANT, requestMasterRestaurant),
    takeLatest(REQUEST_CREATE_MASTER_RESTAURANT, requestCreateMasterRestaurant),
    takeLatest(
      REQUEST_UPDATE_MASTER_RESTAURANT,
      requestUpdateMasterTagRestaurant
    ),
    takeLatest(
      REQUEST_DELETE_MASTER_RESTAURANT,
      requestDeleteMasterTagRestaurant
    ),
  ]);
};

export default restaurantMasterSaga;
